import React, { useState } from 'react';

import Chart from 'react-apexcharts';

import { decimalUpTo } from 'Helpers/currencyFormat';
import { formatSeparateByThousands } from 'Helpers/formatService';

import MinusCircleIcon from 'Assets/icons/minus.svg';
import PlusCircleIcon from 'Assets/icons/plus.svg';

export default function KeyMetricsKeyStatistics(props) {
    const [show, setShow] = useState(true);

    let colorPalette = ['#27B6FF', '#21005C', '#D8C2FF'];
    let numberOfVenuesChartOptions = {};
    let highestCapacityChartOptions = {};

    if (Object.keys(props.summaryKeyStatistics).length > 0) {
        const chartOptions = {
            chart: {
                fontFamily: 'var(--font-sans)',
                type: 'pie',
                width: '100%',
                height: 200,
            },
            dataLabels: {
                enabled: false,
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return decimalUpTo(val.toFixed(0));
                    },
                },
            },
            plotOptions: {
                pie: {
                    customScale: 0.7,
                    donut: {
                        size: '60%',
                        labels: {
                            show: false,
                            value: {
                                show: false,
                            },
                        },
                    },
                    offsetY: 0,
                },
                stroke: {
                    colors: undefined,
                },
            },
            colors: colorPalette,
            title: {
                text: props.name,
                style: {
                    fontFamily: 'var(--font-sans)',
                    fontSize: '18px',
                    color: '#000061',
                },
            },
            legend: {
                show: false,
                floating: false,
                showForNullSeries: true,
                showForZeroSeries: true,
                position: 'bottom',
                height: 80,
            },
        };
        numberOfVenuesChartOptions = {
            ...chartOptions,
            series: [
                props.summaryKeyStatistics.venues_count,
                props.summaryKeyStatistics.competition_venues_count,
                props.summaryKeyStatistics.non_competition_venues_count,
            ],
            labels: ['Total Number of venues', 'No. of competition venues', 'No. of no competition venues'],
        };

        const barOptions = {
            chart: {
                fontFamily: 'var(--font-sans)',
                type: 'bar',
                height: 380,
                width: '100%',
                stacked: false,
                toolbar: {
                    tools: {
                        download: false,
                        pan: false,
                        reset: false,
                        selection: false,
                        zoom: false,
                    },
                },
            },
            tooltip: {
                y: {},
            },
            colors: colorPalette,
            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                opposite: false,
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                labels: {
                    show: false,
                },
            },
            legend: {
                show: false,
            },
            plotOptions: {
                bar: {
                    columnWidth: '50%',
                    distributed: true,
                },
            },
            dataLabels: {
                enabled: false,
            },
        };
        highestCapacityChartOptions = {
            ...barOptions,
            id: 'highest-capacity',
            series: [
                {
                    name: 'Highest Capacity',
                    data: props.summaryKeyStatistics.top_3_venues_by_capacity.map((venue) => venue.capacity),
                },
            ],
        };
    }

    return (
        <div className="tw-border-0 tw-rounded-lg tw-bg-white tw-shadow tw-h-full">
            <div className="tw-p-2.5 tw-flex tw-flex-col tw-gap-3">
                <div className="tw-flex tw-flex-row tw-justify-between tw-pb-3">
                    <div>
                        <h3 className="tw-text-blue tw-text-2xl tw-font-semibold tw-pb-1">{$t('Key Statistics')}</h3>
                    </div>

                    {!show && (
                        <div className={'tw-cursor-pointer'} onClick={() => setShow(true)}>
                            <div className={'tw-h-10 tw-w-10 tw-bg-blue tw-flex tw-justify-center tw-items-center tw-rounded-full'}>
                                <PlusCircleIcon className={'tw-h-3.5 tw-w-3.5 tw-text-white'} />
                            </div>
                        </div>
                    )}
                    {!!show && (
                        <div className={'tw-cursor-pointer'} onClick={() => setShow(false)}>
                            <div className={'tw-h-10 tw-w-10 tw-bg-blue tw-flex tw-justify-center tw-items-center tw-rounded-full'}>
                                <MinusCircleIcon className={'tw-h-3.5 tw-w-3.5 tw-text-white'} />
                            </div>
                        </div>
                    )}
                </div>

                <div>
                    {!!show && (
                        <div className="tw-pb-1">
                            <h4 className="tw-text-black tw-text-sm tw-font-extrabold tw-uppercase">{$t('Venues')}</h4>
                        </div>
                    )}

                    {Object.keys(props.summaryKeyStatistics).length > 0 && !!show && (
                        <div className={'tw-flex tw-gap-3 max-lg:tw-flex-col'}>
                            <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-w-4/12 max-lg:tw-w-full">
                                <div className="tw-p-2.5 tw-flex">
                                    <div className={'tw-flex max-lg:tw-flex-col tw-w-full tw-gap-3'}>
                                        <div
                                            className={'tw-w-5/12 max-lg:tw-w-full'}
                                            style={{
                                                position: 'relative',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    width: '40px',
                                                    height: '40px',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                }}
                                            ></div>
                                            {Object.keys(numberOfVenuesChartOptions).length > 0 && (
                                                <Chart
                                                    options={numberOfVenuesChartOptions}
                                                    series={numberOfVenuesChartOptions.series}
                                                    type={'donut'}
                                                    height={200}
                                                />
                                            )}
                                        </div>
                                        <div className={'tw-w-7/12 max-lg:tw-w-full tw-flex tw-content-center tw-flex-wrap'}>
                                            <ul className={'tw-flex tw-flex-col tw-gap-3 tw-text-xs'}>
                                                <li className={'tw-flex tw-flex-col'}>
                                                    <span className={'tw-w-full tw-font-semibold'}>{$t('Total Number of venues')}</span>
                                                    <span className={'tw-w-full inbud-numeric-text'}>{props.summaryKeyStatistics.venues_count}</span>
                                                </li>
                                                <li className={'tw-flex tw-flex-col'}>
                                                    <span className={'tw-w-full tw-font-semibold'}>{$t('No. of competition venues')}</span>
                                                    <span className={'tw-w-full inbud-numeric-text'}>
                                                        {props.summaryKeyStatistics.competition_venues_count}
                                                    </span>
                                                </li>
                                                <li className={'tw-flex tw-flex-col'}>
                                                    <span className={'tw-w-full tw-font-semibold'}>{$t('No. of no competition venues')}</span>
                                                    <span className={'tw-w-full inbud-numeric-text'}>
                                                        {props.summaryKeyStatistics.non_competition_venues_count}
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-w-4/12 max-lg:tw-w-full">
                                <div className={'tw-p-2.5 tw-flex'}>
                                    <div className={'tw-flex max-lg:tw-flex-col tw-w-full tw-gap-3'}>
                                        <div className={'tw-w-4/12 max-lg:tw-w-full'}>
                                            {Object.keys(highestCapacityChartOptions).length > 0 && (
                                                <Chart
                                                    options={highestCapacityChartOptions}
                                                    series={highestCapacityChartOptions.series}
                                                    type={'bar'}
                                                    height={200}
                                                />
                                            )}
                                        </div>
                                        <div className={'tw-w-8/12 max-lg:tw-w-full tw-flex tw-flex-wrap'}>
                                            <ul className={'tw-flex tw-flex-col tw-gap-3 tw-p-3 tw-w-full'}>
                                                <li className={'tw-flex'}>
                                                    <span className={'tw-w-col tw-text-sm tw-font-medium tw-text-blue-75'}>
                                                        {$t('Highest capacity (top 3)')}
                                                    </span>
                                                </li>
                                                {props.summaryKeyStatistics.top_3_venues_by_capacity.map((row) => {
                                                    return (
                                                        <li
                                                            key={'top_3_venues_by_capacity_' + row.venue_id}
                                                            className={'tw-flex max-lg:tw-flex-col tw-text-xs'}
                                                        >
                                                            <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{row.venue_name}</span>
                                                            <span className={'tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                                                {formatSeparateByThousands(row.capacity)}
                                                            </span>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-w-4/12 max-lg:tw-w-full">
                                <div className={'tw-p-2.5 tw-flex'}>
                                    <div className={'tw-flex max-lg:tw-flex-col tw-w-full tw-gap-3'}>
                                        <div className={'tw-w-full tw-flex tw-flex-wrap'}>
                                            <ul className={'tw-flex tw-flex-col tw-gap-3 tw-p-3 tw-w-full'}>
                                                <li className={'tw-flex'}>
                                                    <span className={'tw-text-sm tw-font-medium tw-text-blue-75'}>{$t('Longest hire period')}</span>
                                                </li>
                                                {props.summaryKeyStatistics.top_3_venues_by_hire_period.map((row) => {
                                                    return (
                                                        <li
                                                            key={'top_3_venues_by_hire_period_' + row.venue_id}
                                                            className={'tw-flex max-lg:tw-flex-col tw-text-xs'}
                                                        >
                                                            <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{row.venue_name}</span>
                                                            <span className={'tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                                                {row.days} {$t('days')}
                                                            </span>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div>
                    {!!show && (
                        <div className="tw-pb-1">
                            <h4 className="tw-text-black tw-text-sm tw-font-extrabold tw-uppercase">{$t('Events')}</h4>
                        </div>
                    )}

                    {Object.keys(props.summaryKeyStatistics).length > 0 && !!show && (
                        <div className={'tw-flex tw-gap-3 max-lg:tw-flex-col tw-text-xs'}>
                            <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-w-4/12 max-lg:tw-w-full">
                                <div className={'tw-p-2.5 tw-flex'}>
                                    <div className={'tw-flex max-lg:tw-flex-col tw-w-full tw-gap-3'}>
                                        <div className={'tw-w-full tw-flex tw-flex-wrap'}>
                                            <ul className={'tw-flex tw-flex-col tw-gap-3 tw-p-3 tw-w-full tw-text-xs'}>
                                                <li className={'tw-flex max-lg:tw-flex-col'}>
                                                    <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{$t('Number of events')}</span>
                                                    <span className={'tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                                        {props.summaryKeyStatistics.sports_count}
                                                    </span>
                                                </li>
                                                <li className={'tw-flex max-lg:tw-flex-col'}>
                                                    <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{$t('Total number of sessions')}</span>
                                                    <span className={'tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                                        {props.summaryKeyStatistics.sessions_count}
                                                    </span>
                                                </li>
                                                <li className={'tw-flex max-lg:tw-flex-col'}>
                                                    <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{$t('Total Number of athletes')}</span>
                                                    <span className={'tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                                        {props.summaryKeyStatistics.athletes_count}
                                                    </span>
                                                </li>
                                                <li className={'tw-flex max-lg:tw-flex-col'}>
                                                    <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{$t('Total number of Officials')}</span>
                                                    <span className={'tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>
                                                        {props.summaryKeyStatistics.officials_count}
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-w-4/12 max-lg:tw-w-full">
                                <div className={'tw-p-2.5 tw-flex'}>
                                    <div className={'tw-flex max-lg:tw-flex-col tw-w-full tw-gap-3'}>
                                        <div className={'tw-w-full tw-flex tw-flex-wrap'}>
                                            <ul className={'tw-flex tw-flex-col tw-gap-3 tw-p-3 tw-w-full'}>
                                                <li className={'tw-flex'}>
                                                    <span className={'tw-text-sm tw-font-medium tw-text-blue-75'}>{$t('Sessions (Top 3)')}</span>
                                                </li>
                                                {props.summaryKeyStatistics.top_3_sports_by_sessions.map((row) => {
                                                    return (
                                                        <li key={'top_3_sports_by_sessions' + row.sport_id} className={'tw-flex max-lg:tw-flex-col tw-text-xs'}>
                                                            <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{row.sport_name}</span>
                                                            <span className={'tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>{row.count}</span>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-w-4/12 max-lg:tw-w-full">
                                <div className={'tw-p-2.5 tw-flex'}>
                                    <div className={'tw-flex max-lg:tw-flex-col tw-w-full tw-gap-3'}>
                                        <div className={'tw-w-full tw-flex tw-flex-wrap'}>
                                            <ul className={'tw-flex tw-flex-col tw-gap-3 tw-p-3 tw-w-full'}>
                                                <li className={'tw-flex'}>
                                                    <span className={'tw-text-sm tw-font-medium tw-text-blue-75'}>{$t('Sessions (Bottom 3)')}</span>
                                                </li>
                                                {props.summaryKeyStatistics.bottom_3_sports_by_sessions.map((row) => {
                                                    return (
                                                        <li
                                                            key={'bottom_3_sports_by_sessions' + row.sport_id}
                                                            className={'tw-flex max-lg:tw-flex-col tw-text-xs'}
                                                        >
                                                            <span className={'tw-w-7/12 max-lg:tw-w-full tw-font-semibold'}>{row.sport_name}</span>
                                                            <span className={'tw-w-5/12 max-lg:tw-w-full inbud-numeric-text'}>{row.count}</span>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
